import { render } from "./CustomerSupport.vue?vue&type=template&id=5129972d&scoped=true"
import script from "./CustomerSupport.vue?vue&type=script&lang=js"
export * from "./CustomerSupport.vue?vue&type=script&lang=js"

import "./CustomerSupport.vue?vue&type=style&index=0&id=5129972d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5129972d"]])

export default __exports__